import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../common.service';
import { ToastrService } from 'ngx-toastr';
import { DefaultComponent } from '../../layout/default/default.component';
import { News } from './news';
declare var $: any;
@Component({
  selector: 'app-kasumbo-add',
  templateUrl: './kasumbo-add.component.html',
  styleUrls: ['./kasumbo-add.component.css']
})
export class KasumboAddComponent implements OnInit, AfterViewInit {
  imageURL1: string;
  news_date = localStorage.getItem('EntryDate');
  name = 'ng2-ckeditor';
  ckeConfig: any;
  news_id: any = '';
  content1: string;
  log: string = '';
  NewsImageURL: string;
  imageURL: string;
  NewsData: News;
  @ViewChild("myckeditor") ckeditor: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public toastr: ToastrService,
    public CommonService: CommonService,
    public DefaultComponent: DefaultComponent
  ) {
    this.content1 = '';
    this.NewsImageURL = environment.baseUrl;
    this.route.params.subscribe(params => this.news_id = params.news_id);
    var param = { news_id: this.news_id };
    if (this.news_id) {
      this.CommonService.getKasumboDetail(param).subscribe((data) => {
        if (data['status']) {
          this.NewsData = data['kasumbo_data']
          if (this.NewsData.image != '') {
            this.imageURL = this.NewsImageURL + '/kasumbo/' + this.NewsData.image;
          }
          this.content1 = this.NewsData.content;
        } else {
          if (data.token_expire) {
            localStorage.removeItem('login_token');
            this.router.navigate(['/']);
          } else {
            this.router.navigate(['/dashboard']);
          }
        }
      });


    }

  }
  ngAfterViewInit(): void {
    setTimeout(function () {
      $('#news_date').datepicker({
        format: "dd-mm-yyyy",
        autoclose: true,
        orientation: "top",
        todayHighlight: true,
      })
    }, 500);
  }
  imageValidation(event, id) {
    const file = (event.target as HTMLInputElement).files[0];
    var mimeType = file.type;
    if (mimeType.match(/image\/*/) == null) {
      $("#image" + id).val('');
      this.toastr.error("Only image are supported.");
      return;
    }
  }
  submit_form() {
    var routers = this.router;
    var th = this;
    $.validate({
      onSuccess: function () {
        th.DefaultComponent.loaderShow();
        //$('.btn-success').attr('disabled', true);
        var form = $("#kasumbo_form");
        var fd = new FormData(form[0]);
        var token = localStorage.getItem('login_token');
        $.ajax({
          url: environment.KasumboBaseUrl + 'add_kasumbo',
          method: 'POST',
          data: fd,
          headers: {
            'Authorization': token
          },
          contentType: false,
          processData: false,
          dataType: 'json',
          success: function (res) {
            th.DefaultComponent.loaderHide();
            if (res.status) {
              th.toastr.success(res.message)
              routers.navigate(['/kasumbo-list']);
            } else {
              if (res.token_expire) {
                localStorage.removeItem('login_token');
                routers.navigate(['/']);
              }
              else {
                th.toastr.error(res.message)
              }
            }
            $('.btn-success').attr('disabled', false);
          }
        });
        return false;
      }
    });
  }
  ngOnInit(): void {
    this.ckeConfig = {
      toolbarGroups: [
        { name: 'document', groups: ['mode'] },
        { name: 'basicstyles', groups: ['basicstyles'] },
        {
          name: 'paragraph',
          groups: ['list', 'align', 'paragraph']
        },
        { name: 'styles', groups: ['styles'] },
        { name: 'colors', groups: ['colors'] },
      ],
      extraPlugins:
        'basicstyles,bidi,blockquote,clipboard,' +
        'button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,' +
        'contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,' +
        'filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,' +
        'font,format,forms,horizontalrule,htmlwriter,iframe,image,indent,' +
        'indentblock,indentlist,justify,link,list,liststyle,magicline,' +
        'maximize,pagebreak,pastefromword,pastetext,' +
        'resize,menubutton,scayt,selectall,showblocks,' +
        'showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,' +
        'tabletools,templates,toolbar,undo,wysiwygarea',
    };
  }
  onChange($event: any): void {
    console.log("onChange");
    //this.log += new Date() + "<br />";
  }
  onPaste($event: any): void {
    console.log("onPaste");
    //this.log += new Date() + "<br />";
  }
}
